import React, { useState, useEffect } from "react";
import { MDBDataTable } from "mdbreact";
import {
  MDBPagination,
  MDBPaginationItem,
  MDBPaginationLink
} from 'mdb-react-ui-kit';
import { Row, Col, Card, CardBody, CardTitle, Button } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { get } from "../../Services/RestAPIService";
import { Link, useNavigate } from "react-router-dom";

const DoctorListing = () => {
  const navigate = useNavigate(); 
  const [data, setData] = useState({
    columns: [
      // {
      //   label: "Select",
      //   field: "select",
      //   sort: "asc",
      //   width: 50,
      // },
      {
        label: "ID",
        field: "id",
        sort: "asc",
        width: 100,
      },
      {
        label: "Image",
        field: "image", // Updated field to "image"
        sort: "asc",
        width: 150,
      },
      {
        label: "Name",
        field: "first_name",
        sort: "asc",
        width: 150,
      },
      {
        label: "Gender",
        field: "gender",
        sort: "asc",
        width: 270,
      },
      {
        label: "Email",
        field: "email",
        sort: "asc",
        width: 200,
      },
      {
        label: "Verification Status",
        field: "is_verified",
        sort: "asc",
        width: 150,
      },
      {
        label: "Last Login",
        field: "last_login",
        sort: "asc",
        width: 100,
      },
      {
        label: "Edit",
        field: "edit",
        sort: "asc",
        width: 100,
      },
    ],
    rows: []
  });
  
  const [isLoading, setIsLoading] = useState(true);
  const [selectedRows, setSelectedRows] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);

  const getUsersData = async (page) => {



    try {
      const usersData = await get(`v1/users/?user_type=Consultant&page=${page}&page_size=5`);
      setData(prevState => ({ ...prevState, rows: usersData.results }));
      setTotalPages(usersData.total_pages);
    } catch (error) {
      console.error('Error fetching user data:', error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getUsersData(currentPage);
  }, [currentPage]);

  const handleEdit = (id) => {
    // Handle edit action here
    navigate(`/edit-consultant/${id}`);

    console.log("Edit button clicked for user with ID:", id);
  };

  const handleCheckboxChange = (id) => {
    const updatedSelectedRows = [...selectedRows];
    const index = updatedSelectedRows.indexOf(id);
    if (index === -1) {
      updatedSelectedRows.push(id);
    } else {
      updatedSelectedRows.splice(index, 1);
    }
    setSelectedRows(updatedSelectedRows);
  };

  const handleButtonClick = () => {
    const selectedIds = selectedRows;
    console.log("Selected IDs:", selectedIds);
  };

  const paginationOptions = {
    entries: 10,
    responsive: true,
    striped: true,
    bordered: false,
    searchLabel: 'Search',
    info: true,
    infoLabel: ['Showing', 'to', 'of', 'entries'],
    paginationLabel: ['<', '>'],
    noRecordsFoundLabel: 'No records found',
    searchPlaceholder: 'Search'
  };

  document.title = "Data Tables | Llosana";

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs maintitle="Home" title="Data" breadcrumbItem="Users" />
          <Row>
            <Col className="col-12">
              <Card>
              <CardBody>
                <CardTitle className="h4">Consultent</CardTitle>

                  <MDBDataTable
                    exportToCSV={true}
                    data={{
                      columns: data.columns,
                      rows: isLoading ? [] : data.rows.map(row => ({
                        ...row,
                        select: <input type="checkbox" checked={selectedRows.includes(row.id)} onChange={() => handleCheckboxChange(row.id)} />,
                        image: <img src={`${row.profile_image || "https://fastly.picsum.photos/id/38/200/200.jpg?hmac=dmdbTgVfAkQ41DmAJKt2u_w6vmqFO_UQ_Ro7F9U-Yws"}`} alt="User" width="50" height="50" />, // Added image column
                        edit: <Button color="primary" onClick={() => handleEdit(row.id)}>Edit</Button>,
                        is_verified: row.is_verified ? 'True' : 'False',
                        last_login: row.last_login instanceof Date ? row.last_login.toLocaleDateString() : row.last_login// Using toLocaleDateString() to get just the date part
                      }))
                    }}
                    responsive={paginationOptions.responsive}
                    striped={paginationOptions.striped}
                    bordered={paginationOptions.bordered}
                    searching={true}
                    searchLabel={paginationOptions.searchLabel}
                    info={paginationOptions.info}
                    infoLabel={paginationOptions.infoLabel}
                    paging={false}
                    paginationLabel={paginationOptions.paginationLabel}
                    entries={paginationOptions.entries}
                    noRecordsFoundLabel={paginationOptions.noRecordsFoundLabel}
                    searchingLabel={paginationOptions.searchPlaceholder}
               
           
                  />

<Button color="primary" onClick={()=>{navigate(`/doctor-form`)}
                  }><i className="typcn typcn-plus"></i> Add New Consultent </Button>
                  {/* <Button onClick={handleButtonClick}>Get Selected IDs</Button> */}
                  {/* <Button onClick={handleButtonClick}>Create User</Button> */}

                  <MDBPagination className="mt-3">
                    <MDBPaginationItem disabled={currentPage === 1}>
                      <MDBPaginationLink onClick={() => setCurrentPage(currentPage - 1)}>Previous</MDBPaginationLink>
                    </MDBPaginationItem>
                    {[...Array(totalPages).keys()].map(page => (
                      <MDBPaginationItem key={page + 1} active={currentPage === page + 1}>
                        <MDBPaginationLink onClick={() => setCurrentPage(page + 1)}>{page + 1}</MDBPaginationLink>
                      </MDBPaginationItem>
                    ))}
                    <MDBPaginationItem disabled={currentPage === totalPages}>
                      <MDBPaginationLink onClick={() => setCurrentPage(currentPage + 1)}>Next</MDBPaginationLink>
                    </MDBPaginationItem>
                  </MDBPagination>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default DoctorListing;
